import { styled } from '@mui/material/styles';
import { DialogActions, Button, Box } from '@mui/material';

export const StyledDialogActions = styled(DialogActions, {
  shouldForwardProp: prop => prop !== 'isMobile'
})<{ isMobile: boolean }>(({ isMobile }) => ({
  padding: isMobile ? 16 : 8,
  ...(isMobile && {
    flexDirection: 'column',
    gap: 8,
    '& > :not(style) + :not(style)': {
      marginLeft: 0
    }
  })
}));

export const StyledResetButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isMobile'
})<{ isMobile: boolean }>(({ isMobile }) => ({
  ...(isMobile && {
    width: '100%',
    order: 3
  })
}));

export const StyledCancelButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isMobile'
})<{ isMobile: boolean }>(({ isMobile }) => ({
  ...(isMobile && {
    width: '100%',
    order: 1
  })
}));

export const StyledSaveButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isMobile'
})<{ isMobile: boolean }>(({ isMobile }) => ({
  ...(isMobile && {
    width: '100%',
    order: 2
  })
}));

export const Spacer = styled(Box)(() => ({
  flexGrow: 1
}));
